




import userManager from "@/services/userManager";
import Vue from "vue";
export default Vue.extend({
  created() {
    let url = "/app/charging_locations";
    if (userManager.checkRole(["cpoAdmin", "cpoMonitor"], false, true)) {
      url = "/app/retailers";
    }
    if (userManager.isUserMobile()) {
      url = "/app/charging_locations_m";
    }
    this.$router.replace(url);
  },
});
